import { keyframes, css } from '@emotion/react';
import styled from '@emotion/styled';
import { ZINDEX } from '@zola/zola-ui/src/styles/emotion';

const show = keyframes`
0% { 
  opacity: 0;
}

100% {
  opacity: 1;
}
`;

export const StyledOverlayWrapper = styled.div<{
  delay: number;
  isSinglePage?: boolean;
  heightPercentage: number;
}>`
  z-index: ${ZINDEX.super};
  animation: ${show} ${props => props.delay}s;
  position: absolute;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  > div {
    height: ${props => props.heightPercentage}%;
  }

  ${props =>
    props.isSinglePage &&
    css`
      position: absolute;

      top: 50%;
      left: 30%;
    `}
`;

export const StyledGlenardenWrapper = styled.div<{
  delay: number;
  isSinglePage?: boolean;
  heightPercentage: number;
}>`
  z-index: ${ZINDEX.super};
  animation: ${show} ${props => props.delay}s;
  position: absolute;
  bottom: 0;
  height: ${props => props.heightPercentage}%;

  display: flex;
  justify-content: center;
  ${props =>
    props.isSinglePage &&
    css`
      position: absolute;

      top: 50%;
      left: 30%;
    `}
`;
